import React from "react";
import './style.scss';
import { Button, Row, Col, Card, Dropdown, Select } from 'antd';
import callIcon from "../../assets/images/call.svg";

const OrderCard = ({ order, acceptOrder, rejectOrder, onChangeExtraTime }) => {
    const generateOptions = () => {
        let time_opt = [];
        for(let i = 0; i < 12; i++){
            time_opt.push({label:`${i*5} min`, value: i*5 })
        }
        return time_opt;
    }
    return <Card
        key={order.id}
        className='order-card'
        bordered={false}
        /* onClick={() => history.push(`/order-details/${order.order_num}`)} */
        bodyStyle={{
            padding: "0"
        }}
        style={{
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
            borderRadius: '10px',
            marginBottom: '1rem',
        }}
    >
        <Row gutter={[16, 16]}>
            <Col xs={24} lg={8}>
                <div style={{ margin: '1rem' }}>
                    <div className="card-type">{order?.order_status?.current_status}</div>
                    <div className="order-id">Order ID: {order.order_num}</div>
                </div>
                <div className="line-b"></div>
                <div style={{ margin: '1rem' }}>
                    <div className="customer-details">Customer Details:</div>
                    <div style={{ display: 'flex', alignContent: 'space-between' }}>
                        <div className="customer-name">{order.customer_name || order?.customer?.name}</div>
                        {order.phone_number ? <a className='call-button' href={'tel:' + order.phone_number}>
                            <img src={callIcon} alt="check" style={{ margin: '.2rem' }} />Call
                        </a> : <></>}
                    </div>
                    <div className="address">{order?.customer_location?.address_field1}, {order?.customer_location?.address_field2}, </div>
                    <div className="address">{order?.customer_location?.city}, {order?.customer_location?.state_province}</div>
                </div>
            </Col>
            <Col className="line-l" xs={24} lg={order.order_status === 'ORDER_PLACED' ? 5 : 6}>
                {
                    order.order_status === 'ORDER_PLACED' ?
                        <div className="mid-card">
                            <div style={{ padding: '1rem 2rem 1rem 2rem' }}>
                                <div style={{ marginBottom: '1rem' }}>
                                    <Button style={{ background: '#23C376', color: 'white', borderRadius: '4px', height: '45px' }} className='primary-greenbtn' onClick={()=>{ acceptOrder(order.order_num) }}>Accept</Button>
                                </div>
                                <div style={{ marginBottom: '1rem' }}>
                                    <Button style={{ borderColor: '#C32340', color: '#C32340', borderRadius: '4px', height: '45px' }} className='accept-call-btn' onClick={()=>{ rejectOrder(order.order_num) }}>Reject</Button>
                                </div>
                            </div>
                            <div className='order-time-font' style={{ display: 'flex', justifyContents: 'space-between', padding: '1rem 1rem 1rem 1rem' }}>
                                <div style={{ marginRight: '1rem' }}>
                                    <div>Order Date:</div>
                                    <div className="created_at">
                                        {order.created_at?.split('T')?.[0]?.split('-')?.reverse()?.join('/')}
                                    </div>
                                </div>
                                <div style={{ marginLeft: 'auto', marginRight: '0' }}>
                                    Order Time:
                                    <div className="created_at">
                                        {new Date(order.created_at)?.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        : <></>
                }
                {
                    order.order_status === 'ORDER_PLACED' ? <></> :
                        <div className="cus_details_wrap">
                            <div className="line-b" style={{ padding: '1rem' }}>
                                <div className="customer-details" style={{ marginBottom: '1rem' }}>Customer Details:</div>
                                <div style={{ display: 'flex', alignContent: 'space-between' }}>
                                    <div className="customer-name">{order.customer_name}</div>
                                    {order.phone_number ? <a className='call-button' href={'tel:' + order.phone_number}>
                                        <img src={callIcon} alt="check" style={{ margin: '.2rem' }} />Call
                                    </a> : <></>}
                                </div>
                                <div className="customer-name">Address:</div>
                                <div className="address">{order?.customer_location?.address_field1}, {order?.customer_location?.address_field2}, </div>
                                <div className="address">{order?.customer_location?.city}, {order?.customer_location?.state_province}</div>
                            </div>
                            <div className="ex_time_wrap">
                                <label>Add/Reduce Extra Time:</label>
                                <div className="">
                                    <Select 
                                        className="extime_select" 
                                        options={generateOptions()}
                                        name="extra_time_mins"
                                        value={generateOptions().filter((extime)=> extime.value == order.extra_time_mins )}
                                        onChange={(e)=>onChangeExtraTime(e, order.order_num)}
                                    />
                                </div>
                            </div>
                        </div>
                }
            </Col>
            <Col className="line-l" xs={24} lg={order.order_status === 'ORDER_PLACED' ? 11 : 10}>
                <div style={{ height: '100%', padding: '1rem 2rem 1rem 2rem' }}>
                    <div style={{ width: '100%' }}>
                        <div className="see-all">See all</div>
                    </div>
                    {order.order_items.slice(0, 3).map((item, i) => (
                        <div key={i} className="order-item">
                            <div>{item.quantity} {item.name}</div>
                            <div className="price">$ {item.price.toFixed(2)}</div>
                        </div>
                    ))}
                    <hr />
                    <div className="card-footer">
                        <div className="total-bill">Total Bill
                            {
                                order.payment_id ? <div className="paid-pill">Paid</div> : <></>
                            }
                        </div>
                        <div className="total-bill total-price">$ {order.price}</div>
                    </div>
                    {
                        order.order_status === 'ORDER_PLACED' ? <></> :
                            <div style={{ marginBottom: '1rem' }}>
                                <Button style={{ backgroundColor: '#C32340', borderColor: '#C32340', color: 'white', borderRadius: '4px', height: '45px' }} className='accept-call-btn'>Notify Customer</Button>
                            </div>
                    }
                </div>
            </Col>
        </Row>
        {['ORDER_PLACED', 'REJECTED'].includes(order.order_status) ? <></> :
            <div className="line-t" style={{ display: 'flex', justifyContent: 'space-between', padding: '1rem 2rem 1rem 2rem' }}>
                <div span={6} style={{ display: 'flex', justifyContent: 'center' }}>
                    <div>
                        <div style={{ paddingBottom: '.5rem' }}>Accepted</div>
                        <div className="order-status-point active"></div>
                    </div>
                </div>
                <div span={6} style={{ display: 'flex', justifyContent: 'center' }}>
                    <div>
                        <div style={{ paddingBottom: '.5rem' }}>Preparing</div>
                        <div className="order-status-point line-before order-line active"></div>
                    </div>
                </div>
                <div span={6} style={{ display: 'flex', justifyContent: 'center' }}>
                    <div>
                        <div style={{ paddingBottom: '.5rem' }}>On The Way</div>
                        <div className="order-status-point line-before order-line inactive"></div>
                    </div>
                </div>
                <div span={6} style={{ display: 'flex', justifyContent: 'center' }}>
                    <div>
                        <div style={{ paddingBottom: '.5rem' }}>Delivered</div>
                        <div className="order-status-point line-before order-line inactive"></div>
                    </div>
                </div>
            </div>
        }
    </Card>
}

export default OrderCard;